import { render, staticRenderFns } from "./AttrFormEl.vue?vue&type=template&id=1c3f43f0&scoped=true&"
import script from "./AttrFormEl.vue?vue&type=script&lang=js&"
export * from "./AttrFormEl.vue?vue&type=script&lang=js&"
import style0 from "./AttrFormEl.vue?vue&type=style&index=0&id=1c3f43f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3f43f0",
  null
  
)

export default component.exports